<template>
  <ant-icon :type="type" :style="{fontSize: fontSize, verticalAlign: verticalAlign, ...cusStyles}" />
</template>

<script>
import Icon from 'ant-design-vue/es/icon'
const AntIcon = Icon.createFromIconfontCN({
  scriptUrl: process.env.VUE_APP_ICONS_URL
  // scriptUrl: '//at.alicdn.com/t/font_2582435_c8ek5zim1wg.js'
})
export default {
  name: 'MenuIcon',
  components: {
    'ant-icon': AntIcon
  },
  props: {
    type: {
      type: String,
      required: true
    },
    fontSize: {
      type: String,
      required: false,
      default: '14px'
    },
    verticalAlign: {
      type: String,
      required: false,
      default: '-0.15em'
    },
    cusStyles: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    }
  }
}
</script>
